import { useMemo } from 'react';
import { useWindowSizes } from '../../../hooks/useAvailableWindowSizes';

export const useGamesLimit = (element) => {
  const { width: windowWidth } = useWindowSizes();
  const width = useMemo(
    () => (element ? element?.getBoundingClientRect()?.width : windowWidth),
    [element, windowWidth]
  );

  return useMemo(() => {
    switch (true) {
      case width >= 1920:
        return 8;
      case width >= 1366:
        return 6;
      case width >= 1024:
        return 8;
      default:
        return 4;
    }
  }, [width]);
};
